import { useState, useEffect } from "react";
import { MenuUnfoldOutlined, MenuFoldOutlined, LogoutOutlined } from "@ant-design/icons";
import { Button, ColorPicker, Layout, Menu, notification, Radio, Space, Switch } from "antd";
const { Header, Sider, Content } = Layout;
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import SmallLogo from "../../Assets/Images/SmallLogo.png";
import profile from "../../Assets/Images/profile1.jpg";
import LargeLogo from "../../Assets/Images/LargeLogo.png";
import DrawerIcon from "../../Assets/Images/chevron-right.png";
import { ImageSlice, logOut } from "../../Utils/UserSlice";
import { handledarkMode } from "../Elements/DarkModeAction";
import { Footer } from "antd/es/layout/layout";
import {
    SunOutlined,MoonOutlined,BgColorsOutlined
   } from "@ant-design/icons"; 
import { setCustomTheme, setTheme } from "../../Store/Reducers/ThemeAction";
import CustomThemeDrawer from "../Elements/CustomThemeDrawer";
import { APIConstants } from "../../Common/APIConstants";
import axios from "axios";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";

 
const SidebarLayout = ({ items, NavItems, DefaultRoute, title }) => {
  const dispatch = useDispatch();
   const { makeRequest, screenNameChecker } = useStoreUpdaterWithAPI(); 
  const [collapsed, setCollapsed] = useState(false);
  const [showMenuIcon, setShowMenuIcon] = useState(true);
  const [screens,setScreens]=useState([])
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState(localStorage.getItem("selectedKey",3) || "3");
  const rs_message = useSelector((state) => state.footer.message);
  // //console.log(rs_message)
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
   const loggedIn = useSelector((state)=>state.user)
    const [logo, setLogo] = useState(null);
  const [background, setBackground] = useState(null);
  // console.log(loggedIn)   
    // console.log(loggedIn.screens)
  
const Version = process.env.REACT_APP_VERSION;
// //console.log(Version)

  useEffect(() => {
    document.body.style.backgroundColor = isdarkMode ? "#292c35" : "#fff";
  }, [isdarkMode]);
  // //console.log(selectedKey)
  const handleNotification = (msg) => {
    notification.open({
      message: msg,
      type: msg.includes("successfully") ? "success" : "error",
      placement: "top",
      duration: 3,
    });
  };
    const validateScreen = (roleId) => {

    const url = `${APIConstants.VALIDATE_SCREEN_API}?RoleId=${roleId}`;

    //console.log(url);
    // //console.log(body);

    makeRequest({
      type: APIConstants.GET, 
      url: url,
      // body: body,
    }).then((res) => {
      console.log(res);
      setScreens(res)
      console.log(res,"screens")
      // dispatch(Userscreen(res));
      // handleNotification("Successfully Deleted", "success");
    });
  };
  useEffect(() => {
 const queryParams = new URLSearchParams(window.location.search);
const userId = queryParams.get("userId");
console.log(userId,"userId");
if(userId){
  validateScreen(userId)
}

}, []);


  const getImages = () => {
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_LOGO_IMAGE}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      console.log(res);
      if (res) {
        setLogo(res?.logo ? `data:image/png;base64,${res?.logo}` : null);
        setBackground(
          res?.backGroundImage
            ? `data:image/png;base64,${res?.backGroundImage}`
            : null
        );
        dispatch(ImageSlice(res));
      }
    });
  };
  useEffect(() => {
    getImages();
  }, []);

  const handleMenuClick = (e) => {
    const clickedKey = e.key;
    setSelectedKey(clickedKey);
    //console.log(clickedKey);
    // localStorage.setItem("selectedKey", clickedKey);
    //console.log(loggedIn.screens)
    //console.log(NavItems)

    const selectedItem = NavItems.find((item) => item.id === clickedKey);
    console.log(selectedItem,"selectedItem") 
    console.log(NavItems,"NavItems")
    console.log(screens,"screens")

    // if (selectedItem) { 
    // if (selectedItem&&screenNameChecker(screens, selectedItem.screenName||"Dashboard")) { 
    //   console.log(screenNameChecker(screens, selectedItem.screenName||"Dashboard"));
      navigate(selectedItem.path);
    // }else{
    //   handleNotification("You are not allowed to access "+ selectedItem.screenName)
    // } 
  };

  const handleLogout = () => {
    dispatch(logOut());
    // navigate("/login",{ replace: true });
    localStorage.removeItem("selectedKey");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 495) {
        setShowMenuIcon(false);
        setCollapsed(true);
      } else {
        setShowMenuIcon(true);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const truncateMessage = (message, limit) => {
    if (message.length <= limit) return message;
  
    // Find the last space within the limit to avoid cutting words
    const trimmed = message.slice(0, limit);
    const lastSpace = trimmed.lastIndexOf(" ");
  
    return trimmed.slice(0, lastSpace) + "..."; // Add ellipsis if truncated
  };
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color)

     const [selectedTheme, setSelectedTheme] = useState("");
     // useEffect(()=>{
     // },[]) 
     const handleChange = (e) => { 
       dispatch(setTheme(e.target.value))
       setSelectedTheme(e.target.value);
      //  //console.log(e.target.value)
       updateColor(e.target.value)
     };
  const [openTheme, setOpenTheme] = useState(false); 

        const switchDarkMode = () => {
          isdarkMode ? dispatch(handledarkMode(false)) : dispatch(handledarkMode(true));
        };
        const showThemeDrawer = () => {
          setOpenTheme(true);
        };
      
        const onThemeClose = () => {
          setOpenTheme(false);
        };
      

        const handleColorChange = (colorResult) => {
          const hex = colorResult.toHexString(); // Convert to hex string
          dispatch(setCustomTheme(hex));
          setSelectedTheme('Custom');
          updateColor(hex);
        };
  
        const updateColor = async (input) => {
          // //console.log(input);
        
          try {
            const response = await axios.post(`${APIConstants.UPDATE_THEME_COLOR_DETAILS}`, {
              autoID: 1,
              primaryColor: input,
              secondryColor: input
            });
        
            // //console.log('Update Color Response:', response.data);
            fetchColor()
          } catch (error) {
            //console.error('Error updating color:', error);
            // Handle error
          }
        };
        
        const fetchColor = async () => {
        
          try {
            const response = await axios.get(`${APIConstants.GET_THEME_COLOR_DETAILS}`);
        
            // //console.log('Meter Data:', response.data);
            if(response.data) {
              const primaryColor = response.data[0].primaryColor;
              // //console.log(primaryColor) 
              if(primaryColor==="green"||primaryColor==="blue"||primaryColor==="red"||primaryColor==="purple"){
                dispatch(setTheme(primaryColor))
              }else{
                dispatch(setCustomTheme(primaryColor))
  
              }
            }
            // Do something with response.data if needed
          } catch (error) {
            //console.error('Error fetching meter data:', error);
            // Handle error
          }
        };
   useEffect(()=>{
    fetchColor()
      },[])
      // console.log(color.themeConfig.colorPrimaryHover)
  return (
    <Layout className={`dark ${isdarkMode ? 'darkmode' : 'whitemode'}` }>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="h-screen z-50 md:w-64 sm:w-32 w-16 pt-14"
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          bottom: 0,
          paddingRight: 1,
          paddingLeft: 1,
          background: isdarkMode ? "#2b4162 linear-gradient(315deg, #2b4162 0%, #12100e 74%)" : color.themeConfig.colorPrimaryHover,
        }}
        // style={{ backgroundColor: color.themeConfig.colorPrimary }}
        // onMouseEnter={() => setCollapsed(false)}
        // onMouseLeave={() => setCollapsed(true)}
      >
        <div className="flex justify-center items-center  -mt-14 pt-2 mb-0 border-b-[1px] pb-2 w-full" 
        style={{ backgroundColor: color.themeConfig.colorPrimaryHover }}
        >
        {collapsed ? 
          <img className="w-12 h-8 " src={SmallLogo} alt="logo" />
        :
        <img className="w-36 h-8" src={LargeLogo} alt="logo" />
        }
        <div className={` ${collapsed? 'ml-2 -mr-7':'ml-5 -mr-8'}  text-white cursor-pointer   text-2xl  bg-[#F5F5F5] rounded-2xl`} onClick={() => setCollapsed(!collapsed)}>
        <img className="w-6 h-6 " src={DrawerIcon} alt="logo" />
        </div>
        </div> 
        <div className={` ${collapsed? 'h-[81%]':'h-[81%]'} overflow-scroll   `}
         style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
         >
        <Menu
          theme={isdarkMode? "dark":"light"} 
          mode="inline"
          defaultSelectedKeys={[selectedKey]}
          items={items}
          className="bg-transparent font-normal z-50 overflow-hidden "
          onClick={handleMenuClick}
        />

        </div>
      
        <div className={` ${isdarkMode? 'text-white':'text-white'} bottom-3 absolute w-full px-1 `}>
        {/* <div className=" mb-3">
        <Radio.Group onChange={handleChange} value={selectedTheme}>
          <Space className="flex flex-wrap w-full text-white pl-1 pb-4" > 
            <Radio value="blue" className="text-white">Blue</Radio>
            <Radio value="green" className="text-white">Green</Radio>
            <Radio value="red" className="text-white">Red</Radio>
            <Radio value="purple" className="text-white">Purple</Radio>
          </Space>
        </Radio.Group>
        </div> */}
        <div className="flex-col w-full"> 
          <div className=" mb-1">
            <Button  className=" flex justify-center items-center  w-full px-3" onClick={()=>showThemeDrawer()}>
            <BgColorsOutlined className="text-xl  mb-1"/>{
              !collapsed?'Theme':""
            }
            </Button> 
          </div>
          <div className="flex justify-between items-center w-full  pb-2 border-b-[1px]">
            <div className="">
              {
                collapsed? <>
                {
                isdarkMode? <MoonOutlined /> : <SunOutlined />
                }
                </>:<>
                {
                isdarkMode? 'Dark Mode' : 'Light Mode'
                }
                </>
              }
            </div>
              <Switch size="small" className="mr-1" checked={isdarkMode} onChange={switchDarkMode} checkedChildren="Dark" unCheckedChildren="Light" />
          </div>
              <div className="flex justify-between items-center my-0 w-full">
                <div className="mb-0 flex justify-center items-center gap-2">
                <img className="w-6 h-6 rounded-xl" src={profile} alt="logo" />
                {
                  !collapsed ? (
                    <p className="text-sm font-semibold text-white mt-0 ">{loggedIn? loggedIn.name : "Admins"}</p>
                  ):<></>
                }
                </div>
              {/* <LogoutOutlined className="text-lg cursor-pointer text-white mr-2" onClick={handleLogout} /> */}
              </div>
            </div>
            <div className="text-white text-xs">
            Version-{Version}
            </div>
        </div>
      </Sider>
      <Layout className="site-layout dark">
        {/* <Header className={`sticky top-0 w-full bg-blue-900 z-10 shadow-md px-0 text-white ${isdarkMode ? 'headermode' : 'whitemode'} py-0 h-12`}>
          {showMenuIcon && (
            <i
              onClick={() => setCollapsed(!collapsed)}
              className="cursor-pointer text-xl absolute top-2 left-2"
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </i>
          )}
          <div className="w-full flex justify-between items-center ml-0 ">
            <img className="w-48 h-8" src={Logo} alt="logo" />
            <div className=""></div>
            <p className="text-lg font-bold mt-2">{title || 'Electrical'}</p>
            <div className="flex mr-5 gap-5"> 
              <Switch checked={isdarkMode} onChange={switchDarkMode} checkedChildren="Dark" unCheckedChildren="Light" />
              <LogoutOutlined className="text-lg cursor-pointer" onClick={handleLogout} />

            </div>
          </div>
        </Header> */}
        <Content className="h-[calc(100vh-120px)]">
          <div className={`p-0 md:p-6 bg-white h-full overflow-auto dark `}>
            <Routes>
              <Route path="/" element={DefaultRoute} />
            </Routes>
            <Outlet />
          </div>
        </Content>
        <div className={`${isdarkMode? "bg-[#3a3c57] ":" " }  min-h-6 `}
        style={{ backgroundColor: !isdarkMode? color.themeConfig.colorPrimaryHover :''}}>
          <p className="font-mono text-sm text-white truncate mb-0">{truncateMessage(rs_message, 200)} </p>
        </div>
      </Layout>
      <CustomThemeDrawer
              title="Close"
              showDrawer={showThemeDrawer}
              open={openTheme}
              onClose={onThemeClose}
      
            >
              <div className="flex flex-col space-y-2">
              <div className=" mb-3">
                <div className={` text-lg  w-fit mb-1  ${ isdarkMode ? " text-white border-gray-400" : "text-black border-white"
              }`}>
                Select Primary Color
              </div>
              <Radio.Group buttonStyle="solid" onChange={handleChange} value={selectedTheme}>
                <Space className="flex flex-wrap w-full text-white pl-0 pb-4" > 
                <Radio.Button value="green" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}>Green</Radio.Button>
                  <Radio.Button value="blue" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}>Blue</Radio.Button>
                 
                  <Radio.Button value="red" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}>Red</Radio.Button>
                  <Radio.Button  value="purple" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}>Purple</Radio.Button>
                </Space>

                <div className={` text-lg  w-fit mb-1  ${ isdarkMode ? " text-white border-gray-400" : "text-black border-white"
              }`}>
                Select Custom Color
              </div>
                <ColorPicker defaultValue="#1677ff" size="large"
                 onChange={handleColorChange}
                 showText
                  />

                <div className="text-xs text-gray-500 mt-2">*Click on the color to select</div>
              </Radio.Group>
              </div>
              <div className=" mb-3">
              <div className={` text-lg w-fit mb-1  ${ isdarkMode ? " text-white border-gray-400" : "text-black border-white"
              }`}>
                Select Theme 
              </div>
              <Radio.Group size="large" buttonStyle="solid" onChange={switchDarkMode} value={selectedTheme}>
                <Space className="flex flex-wrap w-full text-2xl text-white pl-0 pb-4" > 
                  <Radio.Button   value="light" className={` !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}><SunOutlined className="mx-5"/></Radio.Button>
                  <Radio.Button  value="dark" className={`  !rounded-md ${
                isdarkMode ? "bg-gray-800 text-white border-white" : "text-black"
              }`}><MoonOutlined className=" mx-5"/></Radio.Button>
                </Space>
              </Radio.Group>
              </div>
               
              </div>
              {/* <div className="flex justify-center mt-4">
                            <Button
                              type= {isdarkMode? "":'primary'}
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              Search
                            </Button>
              </div> */}
            </CustomThemeDrawer>
    </Layout>
  );
};

export default SidebarLayout;



